import { render, staticRenderFns } from "./assetTypeMng.vue?vue&type=template&id=8957238c&scoped=true"
import script from "./assetTypeMng.vue?vue&type=script&lang=js"
export * from "./assetTypeMng.vue?vue&type=script&lang=js"
import style0 from "./assetTypeMng.vue?vue&type=style&index=0&id=8957238c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8957238c",
  null
  
)

export default component.exports